import HelpCenterRoundedIcon from "@mui/icons-material/HelpCenterRounded";
import { colors } from "@mui/material";
import Box from "@mui/material/Box";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { GridRenderCellParams } from "@mui/x-data-grid-pro";

import ColumnHeader from "@components/Table/ColumnHeader";

import C from "@constants/constants";

const embeddingSearchSpecificColumns = [
  {
    field: "similarityScore",
    renderCell: (parameters: GridRenderCellParams) => {
      const preferredIndustries = parameters.row?.preferredIndustries as string[];
      const sectors = parameters.row?.sector as string[];

      const hasPreferredIndustries = sectors.some(
        (sector) =>
          preferredIndustries &&
          preferredIndustries.some((preferred) => sector.toLowerCase().includes(preferred.toLowerCase())),
      );
      if (parameters.value) {
        return (
          <Tooltip
            placement="bottom"
            title={
              <Box sx={{ display: "flex", flexDirection: "column", gap: 0.5, justifyContent: "center" }}>
                <Typography variant="subtitle2">This company has:</Typography>
                <ul>
                  {parameters.row.numberPatents && (
                    <li>
                      <b>{parameters.row.numberPatents} similar patents</b> related to your technology
                    </li>
                  )}
                  {hasPreferredIndustries && (
                    <li>
                      <b>Presence in specified industries</b>
                    </li>
                  )}
                </ul>
              </Box>
            }
          >
            <Chip
              color="primary"
              label={Number.parseFloat(Number(parameters.value).toFixed(C.SCORE_DECIMAL_PLACES))}
              size="small"
              sx={{
                color: "white",
                cursor: "help",
                fontWeight: 600,
                px: 0.5,
              }}
            />
          </Tooltip>
        );
      }

      return (
        <Tooltip
          placement="bottom"
          title="Innovation Match scores coming soon for companies added from Directory Search."
        >
          <Box alignItems="center" display="flex" flexGrow={1} gap="0.125rem">
            <HelpCenterRoundedIcon
              sx={{
                color: colors.blue[600],
                fontSize: "1rem",
              }}
            />
            <Typography sx={{ fontWeight: 600 }} variant="subtitle2">
              Unavailable
            </Typography>
          </Box>
        </Tooltip>
      );
    },
    renderHeader: () => (
      <ColumnHeader
        title="Innovation Match"
        tooltip="How well this company fits your technology based on patent analysis and SEC data."
      />
    ),
    width: 200,
  },
  {
    field: "numberPatents",
    renderHeader: () => (
      <ColumnHeader title="# Matching Patents" tooltip="Similar IP held by company that match your search." />
    ),
    valueFormatter: (value: string) => (value ? Number.parseInt(value, 10).toLocaleString() : "-"),
    width: 200,
  },
];

export default embeddingSearchSpecificColumns;
